import React, { JSX, ReactNode } from 'react';

import { Fade } from '@/shared/ui/Fade';

import { Container, Header, SSubtitle, Title } from './styled';

type FormContainerProps = {
  title: string;
  children: JSX.Element | JSX.Element[];
  subtitle?: ReactNode;
  subtitleColor?: string;
  onSubmit: () => void;
};

export const FormContainer = ({
  title,
  children,
  subtitle,
  subtitleColor = 'grey.500',
  onSubmit,
}: FormContainerProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const enterKey = e.key === 'Enter';

    if (enterKey) {
      onSubmit();
    }
  };

  return (
    <Fade>
      <Container onKeyDown={handleKeyDown}>
        <Header>
          <Title>{title}</Title>
          <SSubtitle color={subtitleColor} variant="body-1">
            {subtitle}
          </SSubtitle>
        </Header>
        {children}
      </Container>
    </Fade>
  );
};
